import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import '@/styles/milk-auth.css';

const WORDMARK_BLUE = '/assets/logos/wordmark-blue.png';
const WORDMARK_CREAM = '/assets/logos/wordmark-cream.png';
const ASIDE_PHOTO = '/assets/photography/cafe.jpg';

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" /><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" /><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" /><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" /></svg>
);
const MicrosoftIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="#F25022" d="M3 3h8.5v8.5H3z" /><path fill="#7FBA00" d="M12.5 3H21v8.5h-8.5z" /><path fill="#00A4EF" d="M3 12.5h8.5V21H3z" /><path fill="#FFB900" d="M12.5 12.5H21V21h-8.5z" /></svg>
);

export default function LoginPage() {
  const { loginWithGoogle, loginWithMicrosoft } = useAuth();

  return (
    <div className="mlk-auth" data-testid="login-page">
      <div className="auth">
        <div className="auth-form">
          <div className="fw">
            <Link to="/"><img className="brandmark" src={WORDMARK_BLUE} alt="Milk" /></Link>
            <h1>Welcome back</h1>
            <p className="sub">Sign in with Google or Microsoft to keep things moving.</p>

            <div className="sso">
              <button className="btn btn-sso" onClick={loginWithGoogle} data-testid="google-signin-button"><GoogleIcon />Continue with Google</button>
              <button className="btn btn-sso" onClick={loginWithMicrosoft} data-testid="microsoft-signin-button"><MicrosoftIcon />Continue with Microsoft</button>
            </div>

            <p className="legal" style={{ marginTop: 18 }}>
              Milk uses Google or Microsoft to sign you in and to send follow-ups &amp; schedule from your own account.
              We never email or add events without your action.
            </p>
            <p className="legal" style={{ marginTop: 10 }}>
              By continuing, you agree to Milk’s <Link to="/terms" data-testid="login-terms-link">Terms</Link> and <Link to="/privacy" data-testid="login-privacy-link">Privacy Policy</Link>.
            </p>
          </div>
        </div>

        <div className="auth-aside">
          <img className="aside-photo" src={ASIDE_PHOTO} alt="" />
          <div className="aside-scrim" />
          <div className="aside-in">
            <img className="aside-wm" src={WORDMARK_CREAM} alt="Milk" />
            <div className="aside-bot">
              <div className="aside-line">Right where<br />you left off.</div>
              <div className="quote">
                <div className="q">“My follow-ups are teed up before I leave the lobby.”</div>
                <div className="a">Priya N. · Financial Advisor</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
